import Intercom from '@/vendor/intercom';
import config from '@/common/config';

class ErrorHandler {
    static parseError(error, defaultMessage = 'Something went wrong, please try again or contact support') {
        if (config.VUE_APP_DEBUG) {
            console.error(error);
        }
        let errorMessages = [];
        if (error && error.status) {
            switch (error.status) {
                case 401:
                case 404:
                case 409:
                case 400:
                    errorMessages.push(error.message);
                    break;
                case 422:
                    // TODO use invalidFields prop for better details when possible
                    if (error.details && error.details.length) {
                        errorMessages = [
                            ...errorMessages,
                            ...error.details,
                        ];
                    }
                    break;
                case 500:
                    ErrorHandler.sendIntercomError(error);
                    errorMessages.push(`Something went wrong on Rebilly's end, please contact support.`);
                    break;
                default:
                    ErrorHandler.sendIntercomError(error);
                    errorMessages.push(defaultMessage);
            }
        } else if (error && error.name === 'RebillyConflictError') { // error status 409
            errorMessages.push(error.message);
        } else if (error && error.name === 'RebillyCanceledError') {
            // ignore cancel error, request is canceled
            return errorMessages;
        }
        if (errorMessages.length) {
            return errorMessages;
        }
        ErrorHandler.sendIntercomError(error);
        return [defaultMessage];
    }

    static sendIntercomError(error) {
        if (Intercom.isTrackingActive && Intercom.isBooted) {
            Intercom.client('trackEvent', 'Unexpected Javascript Error', {error});
        }
    }
}

export default ErrorHandler;
